import React from 'react';
import { SVGProps } from '@dreamai/types';
import { sanitizedSvg } from '../../../../utils/sanitize';

/**
 * SVG Component for rendering SVG content
 * Sanitizes SVG content to prevent XSS attacks
 */
export const SVGComponent: React.FC<SVGProps> = ({
  dangerouslySetInnerHTML,
  width,
  height,
  viewBox,
  ...rest
}) => {
  const rawHtml = dangerouslySetInnerHTML?.__html || '';

  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      {...sanitizedSvg(rawHtml)}
      {...rest}
    />
  );
};

export default SVGComponent;
